import React from "react";

import Task from "./taskComponent";

const TaskList = ({ configItems, tasks, isPrivilegedUser, openNotes, canApprove, handleCancel, handleSubmit, onDelete, onStatusChange }) => (
  <>
    {tasks?.map(task => (
      <Task
        key={task.id}
        task={task}
        configItems={configItems}
        openNotes={openNotes}
        canApprove={canApprove}
        isPrivilegedUser={isPrivilegedUser}
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
        onDelete={onDelete}
        onStatusChange={onStatusChange}
        tasksList={tasks}
      />
    ))}
  </>
);

export default TaskList;
